/**
 * Spanish (es) mappings for UpgradeToPro
 */

export const upgradeToProES = {
  // Main titles and headers
  "StarCoins": "StarCoins",
  "Pay-Per-Use AI": "IA de Pago por Uso",
  "Get instant access to all premium AI features with StarCoins. No subscription required - just pay for what you use!": "StarCoins son la moneda virtual para uso extendido que nunca expira. No se requiere suscripción para jugar casualmente, pero ofrecemos suscripción Pro para usuarios avanzados con descuentos en monedas. Las monedas se pueden usar para chats extra, giros, quickpicks, o en nuestro mercado para jugadores avanzados.",
  "market for advanced gamers": "mercado para jugadores avanzados",

  // StarCoins section
  "StarCoins System": "Sistema StarCoins",
  "StarCoins are your gateway to unlimited AI-powered sports betting analysis. Purchase coins as needed and use them for advanced features, custom analysis, and extended conversations.": "StarCoins son tu puerta de entrada a análisis ilimitados de apuestas deportivas con IA. Compra monedas según necesites y úsalas para funciones avanzadas, análisis personalizados y conversaciones extendidas.",

  // Star Coins breakdown
  "How Star Coins Work": "Cómo Funcionan las Star Coins",
  "Star Coins": "Star Coins",
  "= 1 QuickPick": "= 1 QuickPick",
  "= 1 xPicks": "= 1 xPicks",
  "= 1 AI Message": "= 1 Mensaje IA",
  "= 1 Game Prediction": "= 1 Predicción de Juego",
  "Never Expire": "Nunca Expiran",
  "Use anytime!": "¡Úsalas cuando quieras!",
  "Use PickStar for your sports betting research now or save for later – your Star Coins never expire!": "Usa PickStar para tu investigación de apuestas deportivas ahora o guarda para después – ¡tus Star Coins nunca expiran!",

  // StarCoin benefits
  "Pay As You Go": "Paga Según Usas",
  "Only pay for what you use. No monthly commitments required.": "Paga solo por lo que uses. Sin compromisos mensuales.",
  "Instant Access": "Acceso Instantáneo",
  "Get immediate access to all AI features without subscription.": "Acceso inmediato a todas las funciones de IA sin suscripción.",
  "Flexible Usage": "Uso Flexible",
  "Scale up or down based on your betting analysis needs.": "Aumenta o disminuye según tus necesidades de análisis.",
  "Bulk Savings": "Ahorro por Volumen",
  "Save more with larger StarCoin packages. Pro members save up to 50%!": "Ahorra más con paquetes más grandes. ¡Miembros Pro ahorran hasta 50%!",

  // Buttons
  "Buy StarCoins Now": "Comprar StarCoins Ahora",
  "Learn More": "Saber Más",
  "Purchase Star Coins": "Comprar Star Coins",
  "Processing...": "Procesando...",

  // Purchase section
  "Choose Your Package": "Elige Tu Paquete",
  "MOST POPULAR": "MÁS POPULAR",
  "POPULAR": "POPULAR",
  "bonus coins": "monedas de bonificación",
  "per 100 coins": "por 100 monedas",
  "Current Balance": "Saldo Actual",
  "Secure checkout powered by Stripe": "Pago seguro con Stripe",
  "Error processing payment. Please try again.": "Error al procesar el pago. Por favor, inténtalo de nuevo.",

  // Pro section
  "Want Even More Value?": "¿Quieres Aún Más Valor?",
  "Upgrade to Pro for built-in usage, discounted StarCoins, and exclusive features": "Actualiza a Pro para uso incluido, StarCoins con descuento y funciones exclusivas",
  "Pro Membership": "Membresía Pro",
  "Pro Benefits Include:": "Beneficios Pro Incluyen:",

  // Pro benefits
  "4x built-in monthly usage included": "4x de uso mensual incluido",
  "Up to 50% discount on all StarCoin purchases": "Hasta 50% de descuento en todas las compras de StarCoins",
  "Priority AI processing queue": "Cola prioritaria de procesamiento de IA",
  "Exclusive Pro-only features": "Funciones exclusivas para Pro",
  "Advanced analytics dashboard": "Panel de análisis avanzado",
  "Priority customer support": "Soporte prioritario al cliente",
  "$50 worth of usage every month": "$50 en uso cada mes",
  "Buy StarCoins at UP TO 50% off regular price": "Compra StarCoins con HASTA 50% de descuento",
  "Never worry about running out mid-analysis": "Nunca te preocupes por quedarte sin créditos durante el análisis",

  // Premium features
  "Premium Features": "Funciones Premium",
  "Advanced capabilities available with both StarCoins and Pro membership": "Capacidades avanzadas disponibles con StarCoins y membresía Pro",

  // Feature titles and descriptions
  "Extended Access & Priority Processing": "Acceso Extendido y Procesamiento Prioritario",
  "Enjoy significantly higher usage limits with priority queue processing for instant responses. Never wait for AI-powered insights when you need them most.": "Disfruta de límites de uso significativamente mayores con procesamiento prioritario para respuestas instantáneas. Nunca esperes por análisis de IA cuando más los necesites.",

  "Complete Conversation History": "Historial Completo de Conversaciones",
  "Access your entire conversation archive with advanced search capabilities. Find specific insights, strategies, and recommendations from any previous session.": "Accede a todo tu archivo de conversaciones con capacidades avanzadas de búsqueda. Encuentra análisis específicos, estrategias y recomendaciones de cualquier sesión anterior.",

  "Advanced Data Analysis Tools": "Herramientas Avanzadas de Análisis de Datos",
  "Upload custom datasets, spreadsheets, and documents for personalized analysis. Transform your raw data into actionable sports betting intelligence.": "Sube conjuntos de datos personalizados, hojas de cálculo y documentos para análisis personalizados. Transforma tus datos brutos en inteligencia accionable para apuestas deportivas.",

  "Personalized AI Recommendations": "Recomendaciones Personalizadas de IA",
  "Receive tailored insights based on your betting patterns, preferences, and historical performance. Our AI learns your style to optimize recommendations.": "Recibe análisis personalizados basados en tus patrones de apuestas, preferencias y rendimiento histórico. Nuestra IA aprende tu estilo para optimizar las recomendaciones.",

  // Additional benefits
  "Additional Pro Benefits": "Beneficios Pro Adicionales",
  "Everything you need for professional-grade sports analytics and betting intelligence.": "Todo lo que necesitas para análisis deportivos e inteligencia de apuestas de nivel profesional.",

  // Benefit items
  "Priority customer support with dedicated assistance": "Soporte prioritario con asistencia dedicada",
  "Early access to new features and beta releases": "Acceso anticipado a nuevas funciones y versiones beta",
  "Advanced analytics dashboard with performance tracking": "Panel de análisis avanzado con seguimiento de rendimiento",
  "Custom prompt templates for specialized analysis": "Plantillas de prompts personalizadas para análisis especializados",
  "Export capabilities for reports and insights": "Capacidades de exportación para informes y análisis",
  "Enhanced security with premium data protection": "Seguridad mejorada con protección premium de datos",

  // Coming Soon section (TEMPORARY)
  "Pro Subscriptions Coming Soon!": "¡Suscripciones Pro Próximamente!",
  "We're working on something special for power users. Stay tuned for exclusive Pro features and discounts!": "Estamos trabajando en algo especial para usuarios avanzados. ¡Mantente atento para funciones y descuentos exclusivos Pro!",
  "In the meantime, enjoy unlimited access with StarCoins - pay only for what you use, no subscription needed!": "Mientras tanto, disfruta acceso ilimitado con StarCoins - ¡paga solo por lo que uses, sin suscripción necesaria!",

  // Button text
  "Upgrade to Pro": "Actualizar a Pro",
  "View Pricing": "Ver Precios",

  // Package display
  "View Packages": "Ver Paquetes",
  "Hide Packages": "Ocultar Paquetes",
  "Choose Your StarCoin Package": "Elige Tu Paquete de StarCoins",
  "Pro members get 50% off all packages!": "¡Miembros Pro obtienen 50% de descuento en todos los paquetes!",
  "Select": "Seleccionar",
  "MOST POPULAR": "MÁS POPULAR",
  "Save": "Ahorra",

  // Package names
  "basic": "Básico",
  "value": "Valor",
  "premium": "Premium",
  "ultimate": "Ultimate"
};
